<template>
    <v-container>
        <!-- header info -->
        <v-row class="pa-4 pb-2">
            <h3>Accommodation changes</h3>
        </v-row> 
        <v-row>
            <v-data-table 
                dense 
                hide-default-footer
                :headers="getHeaders()" 
                :items="data"
                item-key="howz_date_dt"
                :disable-pagination=true>

                <template v-slot:item="howz">
                    <tr>
                        <td>{{ $moment(howz.item.howz_date_dt).format("DD-MM-YYYY") }}</td>
                        <td>{{ howz.item.howz_wijziging_oms }}</td>
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn x-small text icon v-bind="attrs" v-on="on"
                                        v-on:click="editChange(howz.item.howz_encrid)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small>mdi-text-box-edit-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Edit/update this change for all associated bookings</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn x-small text icon v-bind="attrs" v-on="on"
                                        v-on:click="deleteChange(howz.item.howz_encrid, howz.item.howz_wijziging_oms)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small>mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete this change from all associated bookings</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-row>
        <v-row>
            <v-divider />
            <v-spacer />
            <v-btn color="primary" small v-on:click="closeSelect();">Close</v-btn>
        </v-row>
    </v-container>
</template>
  
<script>
    export default {
        components: {
        },  
        props: {
            huis_encrid: {
                type: String,
                required: true
            },
            data: {
                type: Array,
                required: true
            },
        },             
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {                       
            getHeaders() {
                return [
                    { text: "Change date", value: "howz_dt", sortable: true},
                    { text: "Description", value: "howz_wijziging_oms", sortable: false},
                    { text: "", value: "", sortable: false},
                ];
            },
            editChange(howz_encrid) {
                this.$emit('open_dialog', "edit_multiple", howz_encrid, "", "Update change for multiple bookings"); 
            },
            deleteChange(howz_encrid, description) {
                this.$emit('open_dialog', "delete_multiple", howz_encrid, description, "Delete change from all bookings"); 
            },
            // editChangeAll(howz_encrid, change_key) {
            //     this.$emit('executeFunction',  [
            //         {field: 'function', value: 'update_change_all'},  
            //         {field: 'howz_encrid', value: howz_encrid},  
            //         {field: 'change_key', value: change_key}
            //     ]);
            //},
            closeSelect() {
                this.$emit("close_dialog"); 
            },
        }, 
    }

</script>

<style scoped>
    .row-pointer {
      cursor: pointer;
    }
    .button-margin-lr {
        margin-left: 4px;
        margin-right: 4px;
    }
    .button-margin-l {
        margin-left: 4px;
    }  
    .button-margin-r {
        margin-right: 6px;
    }  
    .gridbutton:hover {
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }
</style>